import default_icon from "/icons/default_pfp.svg";
import ai_pfp from "/icons/ai_pfp.svg";
import { styled } from "@linaria/react";
import { type FC, type CSSProperties, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getUserAvatar } from "@/api/user.ts";

const PfpIcon = styled.img`
  width: var(--size);
  height: var(--size);
  border-radius: 100%;
`;

const PfpWrapper = styled.div`
  position: relative;
  height: min-content;
  flex-shrink: 0;
`;

const AiImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export interface ProfileIconProps {
  userId: number;
  name?: string;
  size?: string;
  ai?: boolean;
  aiSize?: number;
}

export const ProfileIcon: FC<ProfileIconProps> = ({ userId, name, size, ai, aiSize, ...props }) => {
  const [fallback, setFallback] = useState(false);
  const profile = useQuery({
    queryFn: () => getUserAvatar(userId),
    queryKey: [`avatar`, userId],
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    enabled: userId !== -1,
  });

  return (
    <PfpWrapper draggable={false} {...props}>
      <PfpIcon
        src={fallback ? default_icon : (profile.data ?? default_icon)}
        alt={`${name} Profile Icon`}
        style={{ "--size": size ?? "24px" } as CSSProperties}
        draggable={false}
        onError={() => setFallback(true)}
      />
      {ai && <AiImage src={ai_pfp} width={aiSize ?? 12} height={aiSize ?? 12} />}
    </PfpWrapper>
  );
};
